import React, { useEffect, useState } from 'react';
import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable,
  ResponderProvided,
} from 'react-beautiful-dnd';
import { MdClose } from 'react-icons/md';
import { Button } from 'src/components';
import { onDragEnd } from 'src/components/DragableTable/onDragEnd';
import UploadImage from 'src/components/upload-image';
import useFetch from 'src/hooks/useFetch';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';

interface IProps {
  handleModal?: any;
  showModal?: any;
  qrEditData?: any;
  title?: string;
  fetchData?: any;
  qrEdit?: any;
  qrData?: any;
  btnLabel?: Element | string;
  slider?: string;
  CheckStatus?: any;
  SetIsSubmitting?: any;
  issaveSlider?: boolean;
  isSubmitting?: boolean;
}

const ImageSlider: React.FC<IProps> = ({
  title,
  btnLabel,
  slider,
  CheckStatus,
  issaveSlider,
  isSubmitting,
  SetIsSubmitting,
}) => {
  const [sliderImages, SetSliderImages] = React.useState<any>([]);
  // const [isSubmitting, SetIsSubmitting] = React.useState<boolean>(false);
  const [imageName, SetImageName] = React.useState<string>('');
  const [toogleUpload, SetToogleUpload] = React.useState<any>(true);
  const userInfoString: string | null = localStorage.getItem('userInfo');
  const businessId: string | undefined = JSON.parse(userInfoString ?? '{}')
    ?.businessInfo?.id;
  const { data: slideData } = useFetch(
    '/settings/' + slider + '/' + businessId
  );
  const handleChange = (file: any, isUpload = false) => {
    SetToogleUpload(isUpload);
    const binaryData = atob(file.split(',')[1]);

    // Calculate the size of the binary data
    const fileSizeInBytes: any = binaryData.length;
    // Convert the size to kilobytes (optional)
    SetSliderImages(
      file === null
        ? [...sliderImages]
        : [
            ...sliderImages,
            {
              url: file,
              name: imageName.replace(/\.[^/.]+$/, ''),
              size: fileSizeInBytes / 1024 / 1024,
            },
          ]
    );
    return file;
  };

  const AddOrderKey = (slideimages: any) => {
    SetSliderImages(
      slideimages.map((item: any, index: number) => ({
        ...item,
        order: index + 1,
      }))
    );
  };

  const removeImageFromArray = (indexToRemove: number) => {
    const updatedSliderImages = sliderImages.filter(
      (_: any, index: number) => index !== indexToRemove
    );
    AddOrderKey(updatedSliderImages);
  };

  useEffect(() => {
    SetToogleUpload(true);
  }, [sliderImages]);

  const onDragEnd = (result: any) => {
    if (!result.destination) return;

    const items = Array.from(sliderImages);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    AddOrderKey(items);
  };

  const saveSliders = async () => {
    SetIsSubmitting(true);
    // localStorage.setItem('sliderImages', JSON.stringify(sliderImages));
    AddOrderKey(sliderImages);
    try {
      await Service.post('/settings/' + slider, sliderImages);
      SetIsSubmitting(false);
      toastAlert('success', 'Images updated');
    } catch (err: any) {
      CheckStatus({ sucess: false, response: err?.response?.data?.message });

      // toastAlert('error', err?.response?.data?.message);
    }

    SetIsSubmitting(false);
  };

  useEffect(() => {
    if (slideData) {
      AddOrderKey(slideData);
    }
  }, [slideData]);

  useEffect(() => {
    issaveSlider && saveSliders();
  }, [issaveSlider]);
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="flex flex-col gap-6">
        {toogleUpload && (
          <UploadImage
            onChange={handleChange}
            name={'slider'}
            label={title || 'Image'}
            cropAsp={2 / 1}
            btnLabel={btnLabel}
            SetImageName={SetImageName}
          />
        )}

        {sliderImages.length !== 0 && (
          <Droppable droppableId="sliderImages">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="flex flex-col -mt-2 ml-3"
              >
                {sliderImages?.map((image: any, index: number) => (
                  <Draggable
                    key={index}
                    draggableId={index.toString()}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="flex gap-2 relative [&:not(:last-child)]:pb-3 items-center"
                      >
                        <div className="flex items-center gap-1 relative">
                          <svg
                            className="cursor-grab absolute translate-x-[calc(-100%-3px)]"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.5 3.75C6.5 3.89834 6.45601 4.04334 6.3736 4.16668C6.29119 4.29001 6.17406 4.38614 6.03701 4.44291C5.89997 4.49968 5.74917 4.51453 5.60368 4.48559C5.4582 4.45665 5.32456 4.38522 5.21967 4.28033C5.11478 4.17544 5.04335 4.0418 5.01441 3.89632C4.98547 3.75083 5.00032 3.60003 5.05709 3.46299C5.11386 3.32594 5.20999 3.20881 5.33332 3.1264C5.45666 3.04399 5.60166 3 5.75 3C5.94891 3 6.13968 3.07902 6.28033 3.21967C6.42098 3.36032 6.5 3.55109 6.5 3.75ZM10.25 4.5C10.3983 4.5 10.5433 4.45601 10.6667 4.3736C10.79 4.29119 10.8861 4.17406 10.9429 4.03701C10.9997 3.89997 11.0145 3.74917 10.9856 3.60368C10.9567 3.4582 10.8852 3.32456 10.7803 3.21967C10.6754 3.11478 10.5418 3.04335 10.3963 3.01441C10.2508 2.98547 10.1 3.00032 9.96299 3.05709C9.82594 3.11386 9.70881 3.20999 9.6264 3.33332C9.54399 3.45666 9.5 3.60166 9.5 3.75C9.5 3.94891 9.57902 4.13968 9.71967 4.28033C9.86032 4.42098 10.0511 4.5 10.25 4.5ZM5.75 7.25C5.60166 7.25 5.45666 7.29399 5.33332 7.3764C5.20999 7.45881 5.11386 7.57594 5.05709 7.71299C5.00032 7.85003 4.98547 8.00083 5.01441 8.14632C5.04335 8.2918 5.11478 8.42544 5.21967 8.53033C5.32456 8.63522 5.4582 8.70665 5.60368 8.73559C5.74917 8.76453 5.89997 8.74968 6.03701 8.69291C6.17406 8.63614 6.29119 8.54001 6.3736 8.41668C6.45601 8.29334 6.5 8.14834 6.5 8C6.5 7.80109 6.42098 7.61032 6.28033 7.46967C6.13968 7.32902 5.94891 7.25 5.75 7.25ZM10.25 7.25C10.1017 7.25 9.95666 7.29399 9.83332 7.3764C9.70999 7.45881 9.61386 7.57594 9.55709 7.71299C9.50033 7.85003 9.48547 8.00083 9.51441 8.14632C9.54335 8.2918 9.61478 8.42544 9.71967 8.53033C9.82456 8.63522 9.9582 8.70665 10.1037 8.73559C10.2492 8.76453 10.4 8.74968 10.537 8.69291C10.6741 8.63614 10.7912 8.54001 10.8736 8.41668C10.956 8.29334 11 8.14834 11 8C11 7.80109 10.921 7.61032 10.7803 7.46967C10.6397 7.32902 10.4489 7.25 10.25 7.25ZM5.75 11.5C5.60166 11.5 5.45666 11.544 5.33332 11.6264C5.20999 11.7088 5.11386 11.8259 5.05709 11.963C5.00032 12.1 4.98547 12.2508 5.01441 12.3963C5.04335 12.5418 5.11478 12.6754 5.21967 12.7803C5.32456 12.8852 5.4582 12.9566 5.60368 12.9856C5.74917 13.0145 5.89997 12.9997 6.03701 12.9429C6.17406 12.8861 6.29119 12.79 6.3736 12.6667C6.45601 12.5433 6.5 12.3983 6.5 12.25C6.5 12.0511 6.42098 11.8603 6.28033 11.7197C6.13968 11.579 5.94891 11.5 5.75 11.5ZM10.25 11.5C10.1017 11.5 9.95666 11.544 9.83332 11.6264C9.70999 11.7088 9.61386 11.8259 9.55709 11.963C9.50033 12.1 9.48547 12.2508 9.51441 12.3963C9.54335 12.5418 9.61478 12.6754 9.71967 12.7803C9.82456 12.8852 9.9582 12.9566 10.1037 12.9856C10.2492 13.0145 10.4 12.9997 10.537 12.9429C10.6741 12.8861 10.7912 12.79 10.8736 12.6667C10.956 12.5433 11 12.3983 11 12.25C11 12.0511 10.921 11.8603 10.7803 11.7197C10.6397 11.579 10.4489 11.5 10.25 11.5Z"
                              fill="#949CC0"
                            />
                          </svg>

                          <img
                            src={image?.url}
                            className="h-[50px] w-[50px] object-cover rounded-md shadow"
                          />
                        </div>
                        <div className="flex  items-center ">
                          <h2>
                            {image?.name?.length > 26
                              ? image?.name?.slice(0, 24) + '...'
                              : image?.name}
                          </h2>
                          {/* <span>{image?.size?.toFixed(2)} MB</span> */}
                        </div>
                        <MdClose
                          className="absolute top-1/2 -translate-y-1/2 right-0 text-xl text-secondary-0"
                          onClick={() => removeImageFromArray(index)}
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        )}
        <div className="flex items-center justify-end">
          <Button
            text={'Save Details'}
            variant="primary"
            onClick={saveSliders}
            isSubmitting={isSubmitting}
          />
        </div>
      </div>
    </DragDropContext>
  );
};

export default React.memo(ImageSlider);
export { onDragEnd as DragEnd };
